import React, { useContext } from "react"
import ReactMarkdown from "react-markdown"
import styled from "styled-components"
import GameContext from "../../../Context/GameContext"
import FallingCards from "./falling-cards/FallingCards"
import { Youtube } from "./Youtube"
import getMediaUrl from "../../../utils/mediaUrl"
import { GlobalOutroResults } from "../global/GlobalOutroResults"
import { layouts } from "../../shared/constants"

const Wrap = styled.div`
  font-size: ${props => props.fontSize};
`
const Text = styled.div`
  ol {
    margin: 0px;
    text-align: left;
  }
  @media (max-height: 800px) {
    font-size: 0.9em;
  }
`
const Img = styled.img`
  max-width: 90%;
  max-height: 30vh;
`
// horizontal left
const WrapLeft = styled.div`
  font-size: ${props => props.fontSize};
  text-align: left;
`
const BodyLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  column-gap: 20px;
`
const ImgLeft = styled.img`
  margin-top: 20px;
  max-width: 40%;
  max-height: 30vh;
`

export const Slide = props => {
  const context = useContext(GameContext)
  const gameProps = context?.gameProps || props?.gameProps || {}
  const slide = props?.slide || {}
  const fallingCards = slide?.description?.includes("falling-cards") || false
  const description = slide?.description?.replace("falling-cards", "") || ""
  const title = slide?.title || slide?.Title || ""
  const imageUrl = slide?.media
    ? getMediaUrl(gameProps?.strapiUrl, slide?.media?.url)
    : null
  const imageAlt = slide?.media?.alternativeText || ""
  const youtube_link = slide?.youtube_link || ""
  const gameOutroResults = slide?.type === "game-outro-results"
  const fontSize = slide?.font_size === "small" ? "0.9em" : "1em"

  const layoutIsHorizontalLeft = slide?.layout === layouts.HORIZONTAL_LEFT
  if (layoutIsHorizontalLeft)
    return (
      <WrapLeft fontSize={fontSize}>
        {title && <h1>{title}</h1>}
        <BodyLeft>
          {imageUrl && <ImgLeft src={imageUrl} alt={imageAlt || title} />}
          {youtube_link && <Youtube url={youtube_link} />}
          <TextArea description={description} />
          {gameOutroResults && <GlobalOutroResults />}
        </BodyLeft>
      </WrapLeft>
    )
  return (
    <Wrap fontSize={fontSize}>
      {title && <h1>{title}</h1>}
      <TextArea description={description} />
      {imageUrl && <Img src={imageUrl} alt={imageAlt || title} />}
      {fallingCards && <FallingCards />}
      {youtube_link && <Youtube url={youtube_link} />}
      {gameOutroResults && <GlobalOutroResults />}
    </Wrap>
  )
}

const TextArea = ({ description }) => {
  const lines = description.split("\n")

  return (
    <Text>
      {lines.map((line, index) => {
        return (
          <div key={index}>
            <ReactMarkdown>{line}</ReactMarkdown>
          </div>
        )
      })}
    </Text>
  )
}
